import { UI_BODY_SM_DF } from "oolib";
import React from "react";
import { useIsThisLinkActive } from "../../../PrimaryHeaderV2/HeaderUI/utils/useIsThisLinkActive";
import { StyledMenuLink } from "../../styled";
import { useGetDisplayForLandingPageLinks } from "../../../../utils/useGetDisplayForLandingPageLinks";

export const HamLink = ({ display: _display, to, thisNavConfig, onClick }) => {
  
  const { display, TextLoader } = useGetDisplayForLandingPageLinks({
    thisNavConfig,
    _display,
  });

  const genDisplay = () =>
    TextLoader ? (
      <TextLoader />
    ) : (
      <UI_BODY_SM_DF semibold={isThisLinkActive({ to }) || undefined}>
        {display}
      </UI_BODY_SM_DF>
    );

  const { isThisLinkActive } = useIsThisLinkActive();
  return (
    <li>
      <StyledMenuLink
        to={to}
        onClick={onClick}
        active={isThisLinkActive({ to })}
      >
       {genDisplay()}
      </StyledMenuLink>
    </li>
  );
};
